module.exports = __webpack_public_path__ + "5a61859027bbec209022515be33ba447.png";